var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrightBankPay = function SvgBrightBankPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brightBankPay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52B6FF",
    fillOpacity: 0.5,
    d: "M9.001 4.6h14v10.8h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29ABE2",
    d: "M.001 2a2 2 0 0 1 2-2h27.997a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2.001a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brightBankPay_svg__b)",
    d: "M.001 2a2 2 0 0 1 2-2h27.997a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2.001a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#brightBankPay_svg__c)",
    d: "M.001 2a2 2 0 0 1 2-2h27.997a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2.001a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.9 6.004h5.548a1.938 1.938 0 1 1 0 3.876H16.9zm0 4.316h5.548a1.938 1.938 0 1 1 0 3.876H16.9zm-4.834 0v-.44h4.465a4.324 4.324 0 0 0-4.465-3.876A4.293 4.293 0 0 0 7.6 10.1a4.293 4.293 0 0 0 4.465 4.096 4.324 4.324 0 0 0 4.465-3.876z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "brightBankPay_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.4324 0 0 27.7756 1.778 19.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#049552",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0D9E74",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1BACAB",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB0B8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "brightBankPay_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(41.6073 0 0 37.9075 7.12 21.178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1FB0B8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C7491",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1A4471",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#18265E",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#181B57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brightBankPay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })))));
};
export default SvgBrightBankPay;